import { objectSchema, ObjectSchema } from "utils/object-methods";
import { ConsigCLTParcelaProps, EmprestimoConsignadoCLTProps } from ".";
import { fieldValidation } from "utils/field-validation";
import { Attendance } from "components/atendimentos-components/atendimento-form/types";
import { revisarCamposComErrors } from "../simulacao-fields/utils";
import { AttendanceActionsTypes } from "contexts/attendance-context/actions-reducer";
import { Dispatch } from "react";
import { CustomTableColorColumn } from "components/dynamic-table/color-table";
import { Checkbox } from "components/checkbox";

export function validateSimulacaoConsignadoCLT(
  fields: Partial<EmprestimoConsignadoCLTProps>,
  dispatch: Dispatch<AttendanceActionsTypes>
) {
  const attendanceFieldErrors = new Map<keyof Attendance, { name: string }>([]);

  const schema: ObjectSchema<EmprestimoConsignadoCLTProps> = {
    banco: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    codeTable: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    cpf: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      if (!isValid) {
        attendanceFieldErrors.set("cpf", { name: "CPF" });
      }
      return { valid: isValid };
    },
    numberInstallments: (value) => {
      return { valid: true };
      // const { isValid } = fieldValidation({ value }).required();
      // return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    observacao: (value) => {
      return { valid: true, format: null };
    },
    optionValue: (value) => {
      return { valid: true };
    },
    value: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return {
        valid: fields.optionValue === 1 ? isValid : true,
        message: "Preencha o campo corretamente",
      };
    },
    valueInstallment: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return {
        valid: fields.optionValue === 2 ? isValid : true,
        message: "Preencha o campo corretamente",
      };
    },
  };

  if (attendanceFieldErrors.size) {
    revisarCamposComErrors(attendanceFieldErrors, dispatch);
  }

  return objectSchema(schema, fields);
}

export function setParcelasCLTConsig(
  newValue: ConsigCLTParcelaProps,
  onChangeField: (
    field: keyof EmprestimoConsignadoCLTProps | "parcelas",
    value: any
  ) => void,
  fields: Partial<
    EmprestimoConsignadoCLTProps & {
      parcelas?: ConsigCLTParcelaProps[];
    }
  >
) {
  onChangeField(
    "parcelas",
    fields.parcelas?.map((p) => {
      if (p.id === newValue.id) {
        if (newValue.checked) {
          onChangeField("numberInstallments", newValue.prazo);
        } else {
          onChangeField("numberInstallments", null);
        }
        return newValue;
      }
      return { ...p, checked: false };
    })
  );
}

export function getEmprestimoConsignadoCLTColumns({
  fields,
  onChangeField,
}: {
  onChangeField: (
    field: keyof EmprestimoConsignadoCLTProps | "parcelas",
    value: any
  ) => void;
  fields: Partial<
    EmprestimoConsignadoCLTProps & {
      parcelas?: ConsigCLTParcelaProps[];
    }
  >;
}): CustomTableColorColumn<ConsigCLTParcelaProps>[] {
  return [
    {
      name: "",
      render: (row) => {
        return (
          <Checkbox
            isChecked={row.checked}
            onChange={(is) =>
              setParcelasCLTConsig(
                { ...row, checked: is },
                onChangeField,
                fields
              )
            }
          />
        );
      },
    },
    {
      name: "Prazo",
      render: (row) => {
        return row.prazo;
      },
    },
    {
      name: "Valor parcela",
      render: (row) => {
        return row.valorParcela;
      },
    },
    {
      name: "Valor liberado",
      render: (row) => {
        return row.valorLiberado;
      },
    },
  ];
}
